export const ROUTES = {
  EMPLOYEE_DETAIL: '/employees',
  ADMIN_SERVICES: '/admin/services',
  ADMIN_CERTIFICATION: '/admin/certification',
  ADMIN_CERTIFICATION_QUESTIONS: '/admin/certification/questions',
  ADMIN_CERTIFICATION_UPLOAD: '/admin/certification/upload',
  ADMIN_CERTIFICATION_SUBMIT: '/admin/certification/submit',
} as const
